/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladderstep13Inputs */

const en_letterpreviewladderstep13 = /** @type {(inputs: Letterpreviewladderstep13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First letter`)
};

const pt_letterpreviewladderstep13 = /** @type {(inputs: Letterpreviewladderstep13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira carta`)
};

/**
* | output |
* | --- |
* | "First letter" |
*
* @param {Letterpreviewladderstep13Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladderstep13 = /** @type {((inputs?: Letterpreviewladderstep13Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladderstep13Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladderstep13(inputs)
	return pt_letterpreviewladderstep13(inputs)
});
export { letterpreviewladderstep13 as "letterPreviewLadderStep1" }